import { Component, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../shared/dataservice.service';
import { GenService } from '../shared/gen-ser.service';
@Component({
  selector: 'nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnChanges {
  isopen:boolean = false;
  router:any;
  dayStr:string = '';
  timeStr:string = '';
  constructor(private _router: Router, public _dataService:DataService) { 
    this.router = _router;
    this.updateTimeLabel(); 
  }

  ngOnChanges() {
  }
  leavefunction(){
    this._dataService._currentSubMenuId = -1;
  }
  overfunction(_lnkOpt:number){    
    if(this._dataService._currentSubMenuId != _lnkOpt)
        this._dataService._currentSubMenuId = _lnkOpt;
    else
        this._dataService._currentSubMenuId = -1;
  }
  linkClicked(){
    this._dataService._currentSubMenuId = -1;
  }
  checkURL(_urlToken:string){
    let _url = this.router.url;
    if(_url.indexOf(_urlToken)>-1){
      return true;
    }
    else{
      return false;
    }
  }

  getWelcomeMessage():string{
    let _username:string = this._dataService.userName;
    if(_username != ''){
      return 'Welcome, ' + _username;
    }
    return '';
  }
  updateTimeLabel(){
    try{
      var _dt = new Date();
      this.dayStr = GenService.getDateFormatStr(_dt,"YYYY-MM-DD WK");
      this.timeStr = GenService.getDateFormatStr(_dt,"hh:mm:ss tt");
    }
    catch{
      this.timeStr = "Err";
    }
    setTimeout(() => {
      this.updateTimeLabel();
    }, 1000);
  }
}
